﻿// requires: js.cookie.js
/* global require */
(function ($) {
    // globals
    var SESS_COOKIE = "efw.tsession";
    var COOKIE_SETTINGS = { sameSite: 'strict', secure: true };
    const Cookies = require('js-cookie');

    // IE8 hack
    Date.now = Date.now || function () { return +new Date; }

    // Eightfold Way sessionTimer plugin
    $.sessionTimer = {};

    // static initialization function
    $.sessionTimer.init = function () {
        // check for existence of session cookie
        var c = Cookies.getJSON(SESS_COOKIE);   // NOTE: Becomes obsolete in js-cookie v3.0.0+. Will have to be much more careful everywhere with JSON assumptions.
        // if not, create it
        if (!c || !c.count) {
            c = { count: 0, start: Date.now() };
        }
        // increment and remember page count
        c.count += 1;
        Cookies.set(SESS_COOKIE, c, COOKIE_SETTINGS);
    };

    $.sessionTimer.get = function () {
        return Cookies.getJSON(SESS_COOKIE);
    }

    // initialize automatically.
    $(document).ready(function () {
        $.sessionTimer.init();
    });
})(jQuery);